import styled from 'styled-components';
import { getTheme } from '../../theme';

const Button = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'theme',
})`
  padding: ${props => getTheme(props.theme?.isDark).spacing.sm} ${props => getTheme(props.theme?.isDark).spacing.md};
  background-color: ${props => {
    if (props.variant === 'outline') return 'transparent';
    if (props.variant === 'danger') return getTheme(props.theme?.isDark).colors.error;
    return getTheme(props.theme?.isDark).colors.primary;
  }};
  color: ${props => {
    if (props.variant === 'outline') return getTheme(props.theme?.isDark).colors.primary;
    return 'white';
  }};
  border: 1px solid ${props => {
    if (props.variant === 'outline') return getTheme(props.theme?.isDark).colors.primary;
    if (props.variant === 'danger') return getTheme(props.theme?.isDark).colors.error;
    return getTheme(props.theme?.isDark).colors.primary;
  }};
  border-radius: ${props => getTheme(props.theme?.isDark).borderRadius.md};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: ${props => getTheme(props.theme?.isDark).fonts.primary};
  display: inline-flex;
  align-items: center;
  gap: ${props => getTheme(props.theme?.isDark).spacing.sm};
  white-space: nowrap;

  &:hover:not(:disabled) {
    background-color: ${props => {
      if (props.variant === 'outline') {
        const primaryColor = getTheme(props.theme?.isDark).colors.primary;
        return `${primaryColor}20`;
      }
      if (props.variant === 'danger') return getTheme(props.theme?.isDark).colors.error;
      return getTheme(props.theme?.isDark).colors.primaryDark;
    }};
    ${props => props.theme?.isDark && `
      box-shadow: 0 0 10px rgba(0, 255, 0, 0.3);
    `}
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export default Button;

